export default {
      id: "video-play-usage",
      viewBox: "0 0 27 19",
      url: __webpack_public_path__ + "img/icons.svg#video-play",
      toString: function () {
        return this.url;
      }
    }